export const idp_status = {
    Draft:{for_mutation:'Draft',for_query:'DRAFT',label:"Draft"},
    Pedning_Approval:{for_mutation:'Pedning_Approval',for_query:'PEDNING_APPROVAL',label:"Pending Approval"},
    Approved:{for_mutation:'Approved',for_query:'APPROVED',label:"Approved"},
    ToDo:{for_mutation:'ToDo',for_query:'TODO',label:"To Do"},
    InProgress:{for_mutation:'InProgress',for_query:'INPROGRESS',label:"In Progress"},
    Completed:{for_mutation:'Completed',for_query:'COMPLETED',label:"Completed"},
    Revise:{for_mutation:'Revise',for_query:'REVISE',label:"Revise"},
}
